import store from '../store'

export default async (to, from, next) => {
    const name = 'Samba Maníacos'
    document.title = to.name === 'home' ? name : `${to.name} - ${name}`
    await store.dispatch('auth/Initialization')

    // Restringe quadno logado
    if ([
        'login',
        'create'
    ].includes(to.name)) {
        await store.dispatch('auth/ActionCheckToken').catch(error => { console.error(error) })
        console.log('before: ', to)
        if (store.getters['auth/hasToken']) {
            next({ name: 'home' })
        }
    } else

    // Se a rota for logout, dispara a ação Sign Out
    if (to.name === 'logout') {
        await store.dispatch('auth/ActionSignOut').catch(error => { console.error(error) })
        next({ name: 'home' })
    } else

    // Acesso somente logado
    if ([
        'certificado',
        'checkout'
    ].includes(to.name)) {
        await store.dispatch('auth/ActionCheckToken').catch(error => { console.error(error) })

        if (!store.getters['auth/hasToken']) {
            next({ name: 'login', query: { from: to.path } })
        }
    }

    // Default
    next()
}
